import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { VenueResponse } from '../../shared/models/VenueResponse';
import { Observable } from 'rxjs';
import { ArticleCategoryResponse } from '../../shared/models/menu/ArticlesCategoryRes';
import { OptionGroupRes } from '../../shared/models/menu/OptionGroup';
import { Legal } from '../../shared/models/Legal';

@Injectable({
	providedIn: 'root',
})
export class VenuesApiService {
	private http = inject(HttpClient);
	constructor() {}

	public getAllVenues() {
		return this.http.get<VenueResponse[]>('/v1/general/venue' + '?customerGroup=' + environment.customerGroup);
	}

	public getVenuesByGeo(lat: number, lng: number, distance: number, articles: boolean) {
		return this.http.get<VenueResponse[]>(
			'/v1/general/venue/' +
				`?lat=${lat}&lng=${lng}&distance=${distance}&articles=${articles}&customerGroup=${environment.customerGroup}`
		);
	}

	public getVenuesBy(postalCode: string) {
		return this.http.get<VenueResponse[]>(
			'/v1/general/venue/' + '?deliveryPostalCode=' + postalCode + '&customerGroup=' + environment.customerGroup
		);
	}

	public getVenue(venueId: string) {
		return this.http.get<VenueResponse>('/v1/general/venue/' + venueId);
	}

	public getCategoriesWithArticles(venue: string, articles: boolean): Observable<ArticleCategoryResponse[]> {
		return this.http.get<ArticleCategoryResponse[]>(
			'/v1/general/' + `articlecategory/?venue=${venue}&articles=${articles}`
		);
	}

	public getOptionGroupsByVenue(venue: string): Observable<OptionGroupRes[]> {
		return this.http.get<OptionGroupRes[]>('/v1/general/' + 'articleoption/byvenue/' + venue);
	}

	public getLegal(venue: string) {
		return this.http.get<Legal>('/v1/general/' + 'venue/' + venue + '/legal');
	}
}
